import React from 'react';
import {
	Card, Row, Col, Button, Form, DatePicker,
	message, Typography, Tooltip, Table, Spin,
} from 'antd';
import {
	SearchOutlined, PrinterOutlined, CopyOutlined,
	CarOutlined, RedoOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import '../../assets/laporan.css';

const { Text } = Typography;

const configClass = {
	title: 'Laporan Penerimaan PNBP',
	apiUrl: { data: 'laporan/api/pnbp/' },
	pageUrl: { cetak: '/laporan/pnbp' },
};

const config = new Config();

const NAVY     = '#0f2847';
const NAVY_MID = '#1a3a6b';

const fmt = (v) => `Rp ${v != null ? Number(v).toLocaleString('id') : '0'}`;
const rp  = (v) =>        v != null ? Number(v).toLocaleString('id') : '0';

class LaporanPnbp extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			loading:  false,
			data:     null,
			err:      false,
			errMsg:   '',
			filter:   '',
			tgl_dari: '',
			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	handleSubmit = () => {
		if (!this.state.tgl_dari) {
			message.warning('Pilih tanggal terlebih dahulu');
			return;
		}
		const filter = `?mulai_dari=${this.state.tgl_dari}`;
		this.setState({ filter });
		this.getData(filter);
	};

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data: this.props.responseMsg, err: false });
				} else {
					this.setState({ loading: false, data: null, err: true, errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loading: false, data: null, err: true, errMsg: 'Gagal koneksi' });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	_kpiCard({ icon, label, value, accent, sub }) {
		return (
			<div style={{
				background: '#fff', borderRadius: 14, padding: '16px 20px',
				border: `1px solid ${accent}22`, boxShadow: `0 2px 12px ${accent}14`,
				display: 'flex', flexDirection: 'column', gap: 6, flex: '1 1 160px', minWidth: 0,
			}}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					<div style={{
						width: 32, height: 32, borderRadius: 9,
						background: `${accent}18`, display: 'flex', alignItems: 'center',
						justifyContent: 'center', fontSize: 15, flexShrink: 0,
					}}>{icon}</div>
					<span style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8 }}>{label}</span>
				</div>
				<div style={{ fontSize: 17, fontWeight: 900, color: accent, fontFamily: 'monospace', lineHeight: 1.1 }}>{value}</div>
				{sub && <div style={{ fontSize: 10, color: '#94a3b8' }}>{sub}</div>}
			</div>
		);
	}

	_sectionTable(title, dot, accent, rows, subtotal) {
		const columns = [
			{
				title: 'No', key: 'no', width: 50, align: 'center',
				render: (_, __, i) => <Text style={{ fontSize: 12, color: '#94a3b8' }}>{i + 1}</Text>,
			},
			{
				title: 'Nomor Polisi', dataIndex: 'nomor_polisi', width: 130,
				render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 12, color: NAVY }}>{v || '—'}</Text>,
			},
			{
				title: 'SD STNK', dataIndex: 'sd_stnk', width: 110,
				render: (v) => <Text style={{ fontSize: 12, color: '#555' }}>{v != null ? v : '—'}</Text>,
			},
			{
				title: 'Jenis Pendaftaran', dataIndex: 'layanan',
				render: (v) => <Text style={{ fontSize: 12 }}>{v || '—'}</Text>,
			},
			{
				title: 'ADM STNK', dataIndex: 'adm_stnk', width: 130, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 600, color: '#1e4d8a' }}>{fmt(v)}</Text>,
			},
			{
				title: 'ADM TNKB', dataIndex: 'adm_tnkb', width: 130, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 600, color: '#1e4d8a' }}>{fmt(v)}</Text>,
			},
			{
				title: 'Jumlah', key: 'jumlah', width: 140, align: 'right',
				render: (_, row) => (
					<Text style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700, color: NAVY }}>
						{fmt((row.adm_stnk || 0) + (row.adm_tnkb || 0))}
					</Text>
				),
			},
		];

		return (
			<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(15,40,71,0.06)', marginBottom: 16 }}>
				{/* Section header */}
				<div style={{ background: `${accent}0e`, padding: '12px 18px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: `1px solid ${accent}22` }}>
					<span style={{ fontSize: 16 }}>{dot}</span>
					<span style={{ fontSize: 13, fontWeight: 700, color: accent, letterSpacing: .8, textTransform: 'uppercase', flex: 1 }}>{title}</span>
					<span style={{ fontSize: 12, color: '#64748b' }}>{rows.length} kendaraan</span>
				</div>

				{/* Table */}
				<div style={{ overflowX: 'auto' }}>
					<Table
						columns={columns}
						dataSource={rows}
						rowKey={(_, i) => i}
						size="small"
						pagination={rows.length > 20 ? { pageSize: 20, showSizeChanger: false, showTotal: (t) => `${t} kendaraan` } : false}
						style={{ minWidth: 680 }}
						summary={() => (
							<Table.Summary.Row style={{ background: `${accent}08` }}>
								<Table.Summary.Cell colSpan={4}>
									<Text style={{ fontSize: 12, fontWeight: 700, color: accent }}>JUMLAH {title} : {rows.length}</Text>
								</Table.Summary.Cell>
								<Table.Summary.Cell align="right">
									<Text style={{ fontFamily: 'monospace', fontWeight: 700, color: accent }}>{fmt(subtotal.jumlah_stnk)}</Text>
								</Table.Summary.Cell>
								<Table.Summary.Cell align="right">
									<Text style={{ fontFamily: 'monospace', fontWeight: 700, color: accent }}>{fmt(subtotal.jumlah_tnkb)}</Text>
								</Table.Summary.Cell>
								<Table.Summary.Cell align="right">
									<Text style={{ fontFamily: 'monospace', fontWeight: 800, color: accent }}>{fmt(subtotal.jumlah_jumlah)}</Text>
								</Table.Summary.Cell>
							</Table.Summary.Row>
						)}
					/>
				</div>
			</div>
		);
	}

	render() {
		const { loading, data, err, filter, tgl_dari, isMobile } = this.state;

		const r4 = data?.roda_empat;
		const r2 = data?.roda_dua;

		const totalKendaraan = data ? ((r4?.jumlah_kendaraan || 0) + (r2?.jumlah_kendaraan || 0)) : 0;
		const totalStnk      = data ? ((r4?.jumlah_stnk || 0)      + (r2?.jumlah_stnk || 0))      : 0;
		const totalTnkb      = data ? ((r4?.jumlah_tnkb || 0)      + (r2?.jumlah_tnkb || 0))      : 0;
		const grandTotal     = data ? ((r4?.jumlah_jumlah || 0)     + (r2?.jumlah_jumlah || 0))    : 0;

		const labelFilter = (txt) => (
			<span style={{ fontSize: 11, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: .5 }}>{txt}</span>
		);

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.pnbp-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 11px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.pnbp-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.pnbp-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.pnbp-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.pnbp-wrap .ant-form-item-label > label { font-weight: 600; color: #475569; font-size: 11px; }
						.pnbp-wrap .ant-picker { border-radius: 8px !important; }
					`}</style>
				</Helmet>

				<div className="pnbp-wrap">
					<Row gutter={[0, 16]}>

						{/* ══ FILTER PANEL ══ */}
						<Col span={24}>
							<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(15,40,71,0.07)' }}>

								{/* Header dark navy */}
								<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
									<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
										<div style={{ width: 38, height: 38, background: 'rgba(251,191,36,0.15)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19 }}>📋</div>
										<div>
											<div style={{ fontSize: 15, fontWeight: 700, color: '#fff', letterSpacing: .3 }}>{configClass.title}</div>
											<div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>Rekapitulasi penerimaan PNBP (ADM STNK + ADM TNKB)</div>
										</div>
									</div>
									{data && (
										<Tooltip title="Cetak laporan">
											<a href={configClass.pageUrl.cetak + filter} target="_blank" rel="noopener noreferrer">
												<Button icon={<PrinterOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', color: '#fff', fontWeight: 600 }}>
													{!isMobile && 'Cetak'}
												</Button>
											</a>
										</Tooltip>
									)}
								</div>

								{/* Filter form */}
								<Form
									layout="vertical" name="fdata" ref={this.formRef}
									onFinish={this.handleSubmit} size="small" disabled={loading}
									style={{ padding: '18px 20px 14px' }}
								>
									<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '0 16px' }}>
										<Form.Item label={labelFilter('Pilih Tanggal')} style={{ marginBottom: 10 }}>
											<DatePicker
												placeholder="dd-mm-yyyy"
												format="DD-MM-YYYY"
												style={{ width: '100%', borderRadius: 8 }}
												onChange={(date, dateString) => this.setState({ tgl_dari: dateString })}
											/>
										</Form.Item>
									</div>

									<div style={{ display: 'flex', gap: 10, paddingTop: 4 }}>
										<Button
											key="btn-proses" loading={loading} type="primary" htmlType="submit"
											disabled={loading} icon={!loading && <SearchOutlined />}
											style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 700, background: NAVY, borderColor: NAVY }}
										>
											Proses Laporan
										</Button>
										{data && (
											<a href={configClass.pageUrl.cetak + filter} target="_blank" rel="noopener noreferrer">
												<Button
													icon={<PrinterOutlined />} htmlType="button"
													style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 600 }}
												>
													Cetak
												</Button>
											</a>
										)}
									</div>
								</Form>
							</div>
						</Col>

						{/* ══ LOADING ══ */}
						{loading && (
							<Col span={24}>
								<div style={{ background: '#fff', borderRadius: 14, padding: '36px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
									<Spin size="large" />
									<div style={{ marginTop: 12, color: '#64748b', fontSize: 13 }}>Memproses laporan, mohon tunggu...</div>
								</div>
							</Col>
						)}

						{/* ══ EMPTY STATE ══ */}
						{!data && !loading && !err && (
							<Col span={24}>
								<div style={{ background: '#fff', borderRadius: 14, padding: '48px 24px', textAlign: 'center', border: '1px solid #e2e8f0', color: '#aaa' }}>
									<div style={{ fontSize: 36, marginBottom: 12 }}>📋</div>
									<div style={{ fontSize: 14 }}>Pilih tanggal dan tekan <b>Proses Laporan</b> untuk menampilkan data</div>
								</div>
							</Col>
						)}

						{/* ══ ERROR STATE ══ */}
						{err && !loading && (
							<Col span={24}>
								<div style={{ background: '#fff1f0', borderRadius: 14, padding: '36px 24px', textAlign: 'center', border: '1px solid #ffa39e', color: '#cf1322' }}>
									<div style={{ fontSize: 14, fontWeight: 600 }}>Gagal memuat laporan. Periksa koneksi atau coba kembali.</div>
								</div>
							</Col>
						)}

						{/* ══ HASIL LAPORAN ══ */}
						{data && !loading && (
							<>
								{/* Info bar */}
								<Col span={24}>
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
										<div>
											<div style={{ fontSize: 15, fontWeight: 700, color: NAVY }}>Rekapitulasi Penerimaan PNBP</div>
											<div style={{ fontSize: 12, color: '#64748b' }}>
												SAMSAT {data.upt} &nbsp;·&nbsp; Tanggal: {tgl_dari}
											</div>
										</div>
									</div>
								</Col>

								{/* KPI Cards */}
								<Col span={24}>
									<div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
										<div style={{
											background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`,
											borderRadius: 14, padding: '18px 22px', flex: '1 1 180px', minWidth: 0,
											boxShadow: '0 4px 18px rgba(15,40,71,0.2)',
										}}>
											<div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>💰 GRAND TOTAL PNBP</div>
											<div style={{ fontSize: 20, fontWeight: 900, color: '#fbbf24', fontFamily: 'monospace', lineHeight: 1 }}>{fmt(grandTotal)}</div>
											<div style={{ fontSize: 10, color: '#64748b', marginTop: 6 }}>{totalKendaraan} kendaraan terdaftar</div>
										</div>
										{this._kpiCard({ icon: '🚗', label: 'Kendaraan Roda 4', value: rp(r4?.jumlah_kendaraan),      accent: '#1d4ed8', sub: fmt(r4?.jumlah_jumlah) })}
										{this._kpiCard({ icon: '🛵', label: 'Kendaraan Roda 2', value: rp(r2?.jumlah_kendaraan),      accent: '#0891b2', sub: fmt(r2?.jumlah_jumlah) })}
										{this._kpiCard({ icon: '📄', label: 'Total ADM STNK',   value: fmt(totalStnk),                  accent: '#047857' })}
										{this._kpiCard({ icon: '🔖', label: 'Total ADM TNKB',   value: fmt(totalTnkb),                  accent: '#7c3aed' })}
									</div>
								</Col>

								{/* Tabel Roda 4 */}
								{r4 && r4.data && r4.data.length > 0 && (
									<Col span={24}>
										{this._sectionTable('Kendaraan Roda 4', '🚗', '#1d4ed8', r4.data, r4)}
									</Col>
								)}

								{/* Tabel Roda 2 */}
								{r2 && r2.data && r2.data.length > 0 && (
									<Col span={24}>
										{this._sectionTable('Kendaraan Roda 2', '🛵', '#0891b2', r2.data, r2)}
									</Col>
								)}

								{/* Grand Total Bar */}
								<Col span={24}>
									<div style={{
										background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`,
										borderRadius: 14, padding: '18px 24px',
										display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12,
										boxShadow: '0 4px 20px rgba(15,40,71,0.2)',
									}}>
										<div>
											<div style={{ fontSize: 11, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>TOTAL SELURUH PENERIMAAN PNBP</div>
											<div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
												{[
													{ label: 'Roda 4',    val: r4?.jumlah_jumlah },
													{ label: 'Roda 2',    val: r2?.jumlah_jumlah },
													{ label: 'ADM STNK', val: totalStnk },
													{ label: 'ADM TNKB', val: totalTnkb },
												].map((s, i) => (
													<div key={i} style={{ fontSize: 11, color: '#94a3b8' }}>
														{s.label}: <span style={{ color: '#cbd5e1', fontWeight: 600 }}>{fmt(s.val)}</span>
													</div>
												))}
											</div>
										</div>
										<div style={{ fontSize: 26, fontWeight: 900, color: '#fbbf24', fontFamily: 'monospace' }}>{fmt(grandTotal)}</div>
									</div>
								</Col>

								{/* Tanda Tangan */}
								{data.ttd && (
									<Col span={24}>
										<div style={{ background: '#fff', borderRadius: 14, padding: '20px 24px', border: '1px solid #e2e8f0' }}>
											<Row justify="space-between">
												{data.ttd.kiri && (
													<Col span={10} style={{ textAlign: 'center' }}>
														<div style={{ fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 4 }}>MENGETAHUI</div>
														<div style={{ fontSize: 12, color: '#64748b' }}>{data.ttd.kiri.jabatan}</div>
														<div style={{ marginTop: 52, paddingTop: 8, borderTop: '1px solid #e2e8f0' }}>
															<div style={{ fontSize: 13, fontWeight: 700, color: NAVY }}><u>{data.ttd.kiri.nama}</u></div>
															<div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>NIP : {data.ttd.kiri.nip}</div>
														</div>
													</Col>
												)}
												{data.ttd.kanan && (
													<Col span={10} style={{ textAlign: 'center' }}>
														<div style={{ fontSize: 12, color: '#64748b' }}>{data.upt}, {moment().format('DD-MM-YYYY')}</div>
														<div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{data.ttd.kanan.jabatan}</div>
														<div style={{ marginTop: 52, paddingTop: 8, borderTop: '1px solid #e2e8f0' }}>
															<div style={{ fontSize: 13, fontWeight: 700, color: NAVY }}><u>{data.ttd.kanan.nama}</u></div>
															<div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>NIP : {data.ttd.kanan.nip}</div>
														</div>
													</Col>
												)}
											</Row>
										</div>
									</Col>
								)}
							</>
						)}

					</Row>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(LaporanPnbp);
